// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2mGlq","requiredAsterisk":"Info_requiredAsterisk__aWZe5"};